import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { BundleDiscountBanner } from 'components/ProductDetail/BundleDiscountBanner';
import { PrideDiscountBanner } from 'components/ProductDetail/PrideDiscountBanner';
import ZipPayInfo from './ZipPayInfo';
import AfterPayInfo from './AfterPayInfo';

export default function ProductBadge({ calculateAfterPay }: { calculateAfterPay?: number }) {
    const router = useRouter();

    const regionSettings = {
        'international': {
            'prescription-glasses': <PrideDiscountBanner />,
            'prescription-sunglasses': <PrideDiscountBanner />,
            'blue-light-filter-glasses': <PrideDiscountBanner />,
            'reading-glasses': <PrideDiscountBanner />,
            'sunglasses': <PrideDiscountBanner />
        },
        'au': {
            'prescription-glasses': <PrideDiscountBanner />,
            'prescription-sunglasses': <PrideDiscountBanner />,
            'blue-light-filter-glasses': <PrideDiscountBanner />,
            'reading-glasses': <PrideDiscountBanner />,
            'sunglasses': <PrideDiscountBanner />
        },
        'nz': {
            'prescription-glasses': <PrideDiscountBanner />,
            'prescription-sunglasses': <PrideDiscountBanner />,
            'blue-light-filter-glasses': <PrideDiscountBanner />,
            'reading-glasses': <PrideDiscountBanner />,
            'sunglasses': <PrideDiscountBanner />
        },
        'ca': {
            'prescription-glasses': <PrideDiscountBanner />,
            'prescription-sunglasses': <PrideDiscountBanner />,
            'blue-light-filter-glasses': <PrideDiscountBanner />,
            'reading-glasses': <PrideDiscountBanner />,
            'sunglasses': <PrideDiscountBanner />
        },
    }

    const getRealPath = (pathname: string) => {
        if (pathname && pathname.includes('/')) {
            const path = pathname.split('/');
            if (path.length > 2) {
                return path[2];
            }
        }
        return pathname;
    }

    const banners = useMemo(() => {
        const path = getRealPath(router.asPath);
        return regionSettings[router.locale as keyof typeof regionSettings]?.[path as keyof typeof regionSettings[keyof typeof regionSettings]]
    }, [router.locale, router.pathname]);

    return (
        <>
            {banners}
        </>
    );
}
